import classNames from 'clsx';
import MaterialSlider from 'material-ui/Slider';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { player } from 'src/client/player';
import css from './scrubber.module.scss';

const SLIDER_MAX = 100;

export default class Slider extends Component {
  static propTypes = {
    disabled: PropTypes.bool.isRequired,
    className: PropTypes.string,
    sliderMax: PropTypes.number.isRequired,
    elapsedPercent: PropTypes.number.isRequired,
    onChangeCommitted: PropTypes.func.isRequired,
    isInNowPlayingDialog: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      scrubbingPercent: 0,
    };

    this.onChange = this.onChange.bind(this);
    this.onDragStop = this.onDragStop.bind(this);
  }

  onChange(event, scrubbingPercent) {
    const nextValue = (scrubbingPercent / 100) * player.getDuration();

    this.setState({ scrubbingPercent: nextValue });
  }

  onDragStop() {
    this.props.onChangeCommitted(this.state.scrubbingPercent);
  }

  render() {
    const { disabled, sliderMax, elapsedPercent, isInNowPlayingDialog, className } = this.props;

    const sliderCss = isInNowPlayingDialog ? css.nowPlayingSlider : css.slider;

    return (
      <MaterialSlider
        id="scrubber"
        data-testid={`scrubber-disabled-${disabled}`}
        disableFocusRipple
        className={classNames(sliderCss, className, {
          [css.disabled]: disabled,
        })}
        disabled={disabled}
        value={Math.min(elapsedPercent, SLIDER_MAX)}
        max={sliderMax}
        onChange={this.onChange}
        onDragStop={this.onDragStop}
        sliderStyle={{ margin: 0 }}
      />
    );
  }
}
